module.exports = __webpack_public_path__ + "img/new-digital.70e50d0a.svg";